import React from "react";
// import { openContactSelector } from "../../common/callUtil"
// getUrl
import { searchAsset, findStation } from "../../lib/masterUtil";
import masterData from "../../lib/masterData";
import PropTypes from "prop-types";
// import areas from "../../common/areas";
// import { getAssetUrl } from "../../lib/masterUtil";
// import { Link } from "../../lib/Link";
// import AnchorLink from 'react-anchor-link-smooth-scroll';

export class Carrieservice extends React.Component {
  state = {};
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props);
    this.context = context;
    this.state = this.getState(props, context);
  }
  /* eslint-disable complexity */
  getState(props, context) {
    const paramsString = props.location.search;
    const searchParams = new URLSearchParams(paramsString);
    const value = { condition: {} };
    for (const [paramKey, paramValue] of searchParams) {
      if (paramValue[0] === '(') {
        if (paramValue.length > 2) {
          value.condition[paramKey] = paramValue.slice(1, -1).split('.');
        }
      } else {
        value.condition[paramKey] = paramValue;
      }
    }
    // console.log('condition = ', value.condition )
    const params = props.match.params;
    const line = params && params.line ? masterData.line.bySlug[params.line] : null;
    const stationId = params && findStation(line, params.station)
    console.log('getState', line, stationId)
    if (line) {
      value.condition = value.condition || {};
      value.condition.line = [line.slug];
    }
    if (stationId) {
      value.condition = value.condition || {};
      value.condition.station = [stationId];
    }
    const pref = params.pref ? masterData.pref.bySlug[params.pref] : null;
    let city_slug = params.city;
    if (params.district) {
      city_slug = params.city + params.district;
    }
    const city = pref && city_slug ? masterData.city.byPrefAndSlug[pref.prefId][city_slug] : null;
    // const district = city && city.districtSlug ? city.districtSlug : null;
    if (pref) {
      value.condition = value.condition || {};
      value.condition.pref = value.condition.pref || pref.prefId;
    }
    if (city) {
      value.condition = value.condition || {};
      value.condition.city = value.condition.city || [city.slug];
    }
    const list = searchAsset(value, {});
//    console.log("new value", value, list);
    return {
      value,
      list,
      activeIndex: null,
    };
  }

  togglePref = selectedPrefId => {
    this.setState({ selectedPrefId: selectedPrefId });
  };

  render() {
    // const carrieserviceObjs = this.state.list.filter(x => x.objCarrieserviceKbn === 1);

    // const selectedAssets = (selectedPrefId) => {
    //   selectedPrefId = selectedPrefId ? selectedPrefId : 13;
    //   const as = carrieserviceObjs.filter(x => x.pref === selectedPrefId);
    //   if (as && as.length > 0) {
    //     return(
    //       <div className="property-List">
    //         <h3>{selectedPrefId && masterData.pref.byId[selectedPrefId].shortName}</h3>
    //         <ul>
    //           {as.map((asset, index) => {
    //             const assetIcon = masterData.assetIcon.bySlug[asset.assetIcon];
    //             let url = getAssetUrl(asset);
    //             return(
    //               <li>
    //                 <Link to={url} key={index} target="_blank">
    //                   <a href="#" title={asset.name} target="_blank">
    //                     <span className="type">
    //                       <div><img src={assetIcon && assetIcon.icon} /></div>
    //                     </span>{asset.name}
    //                   </a>
    //                 </Link>
    //               </li>
    //             )
    //           })}
    //         </ul>
    //       </div>
    //     )
    //   } else {
    //     return(
    //       <div className="property-List">
    //         <h3></h3>
    //         <ul>
    //         </ul>
    //       </div>
    //     )
    //   }
    // }

    document.title =
      "トランクルームをお探しなら『ハローストレージ』【公式】 | ハロー宅配便";

    // const areaSplit = [areas.slice(0, 3), areas.slice(3, 6)];

    return (
      <div className="carrieservice">
        <div id="firstview" className="firstview">
            <div className="firstview-img">
                <h1><img className="pc-show" src="resource/img/static/carrieservice/main-visual.png?20220708" alt="家具や段ボールなど大きな荷物の運搬はお任せ！ハロー宅配便"/></h1>
                <h1><img className="sp-show" src="resource/img/static/carrieservice/main-visual_sp.png?20220708" alt="家具や段ボールなど大きな荷物の運搬はお任せ！ハロー宅配便"/></h1>
            </div>
        </div>

        <section id="hello-delivery" className="hello-delivery">
            <div className="container">
                <h3 className="pc-show"><img src="resource/img/static/carrieservice/about.png" alt="ハロー宅配便とは"/></h3>
                <h3 className="sp-show"><img src="resource/img/static/carrieservice/about_sp.png" alt="ハロー宅配便とは"/></h3>
                <h4 className="pc-show"><img src="resource/img/static/carrieservice/about_text.png" alt="ハロー宅配便とは"/></h4>
                <h4 className="sp-show">ご自宅のお荷物の搬出からトランクルームへ<br/>搬入までをお手伝いするサービスです。<br/>お荷物の搬出から搬入まで、<br/>専門スタッフが敏速に対応します。</h4>
                <div className="hello-delivery-box">
                    <div className="hello-delivery-item pc-show">
                      <img src="resource/img/static/carrieservice/carry.png" alt="搬出 スタッフがお荷物の搬出をいたします。搬入 スタッフがお荷物をトランクルームに搬入いたします。"/>
                    </div>
                    <div className="hello-delivery-item sp-show">
                      <img src="resource/img/static/carrieservice/carry_out_sp.png" alt="搬出 スタッフがお荷物の搬出をいたします。"/>
                    </div>
                    <div className="hello-delivery-item sp-show">
                      <img src="resource/img/static/carrieservice/carry_in_sp.png" alt="搬入 スタッフがお荷物をトランクルームに搬入いたします。"/>
                    </div>
                </div>
                <div className="hello-delivery-ribbon sp-show"><img src="resource/img/static/carrieservice/ribbon1_sp.png" alt="運搬・搬入はお任せ！"/></div>
                <h3 className="priceH3 pc-show"><img src="resource/img/static/carrieservice/price.png" alt="料金について"/></h3>
                <h3 className="priceH3 sp-show"><img src="resource/img/static/carrieservice/price_sp.png" alt="料金について"/></h3>
                <p className="price-table pc-show"><img src="resource/img/static/carrieservice/table price.png?20230410" alt="料金表"/></p>
                <p className="price-table sp-show"><img src="resource/img/static/carrieservice/table price_sp.png?20230410" alt="料金表"/></p>
                <div className="price">
                <p className="price-txt">搬出元から搬入先までの運搬距離は最大で50kmです。<br/>50kmを超える場合は別途料金が発生する可能性がございます。</p>
                </div>
                <p className="price-area pc-show">
                  <a href="simulator" target="_blank">
                    <img src="resource/img/static/carrieservice/movie_btn.png" alt="サイズ選びに困ったら収納シュミレーション動画はこちら"/>
                  </a>
                </p>
                <p className="price-area sp-show">
                  <a href="simulator" target="_blank">
                    <img src="resource/img/static/carrieservice/movie_btn_sp.png" alt="サイズ選びに困ったら収納シュミレーション動画はこちら"/>
                  </a>
                </p>
                <p className="price-area pc-show"><img src="resource/img/static/carrieservice/area.png" alt="サービス対応エリア"/></p>
                <p className="price-area sp-show"><img src="resource/img/static/carrieservice/area_sp.png" alt="サービス対応エリア"/></p>
            </div>

            <div className="apply-container">
                <h3 className="applyH3 pc-show"><img src="resource/img/static/carrieservice/apply.png" alt="お申し込みの流れ"/></h3>
                <h3 className="applyH3 sp-show"><img src="resource/img/static/carrieservice/apply_sp.png" alt="お申し込みの流れ"/></h3>
                <p className="apply-flow sp-show"><img src="resource/img/static/carrieservice/flow_sp.png" alt="お申し込みの流れ"/></p>
                <div className="apply-flowarea1 pc-show">
                    <div className="apply-flow1">
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow1.png" alt="お申し込み"/></p>
                            <p className="apply-txt">お申し込み後、運搬サービス専用フォームをお送りいたします。希望日程・お荷物の詳細についてご記入ください。</p>
                        </div>
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow2.png" alt="梱包"/></p>
                            <p className="apply-txt">お荷物を梱包してお待ちください。</p>
                        </div>
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow3.png" alt="搬出"/></p>
                            <p className="apply-txt">スタッフがお荷物の搬出をいたします。</p>
                        </div>
                    </div>
                </div>
                <div className="apply-flowarea2 pc-show">
                    <div className="apply-flow2">
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow4.png" alt="搬入"/></p>
                            <p className="apply-txt">スタッフがお荷物をトランクルームへ<br/>搬入いたします。</p>
                        </div>
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow5.png" alt="鍵返却"/></p>
                            <p className="apply-txt">お預かりした鍵を宅急便でご返却いたし<br/>ます。</p>
                        </div>
                        <div className="apply-flow-item">
                            <p><img src="resource/img/static/carrieservice/flow6.png" alt="完了報告"/></p>
                            <p className="apply-txt">お荷物搬入後の写真をお送りいたします。<br/>ご確認ください。</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="notes">
                <p className="apply-kome-txt">
                  ※有料運搬サービスに関するご案内・荷物の運搬は、東都クリエート株式会社へ委託しております。<br/>
                  ※お荷物の内容や運搬ルート、日程により東都クリエート株式会社よりご連絡させていただく場合がございます。<br/>
                  ※搬出入にお立会いいただくこともできます。<br/>
                  ※お荷物の搬出は１か所に限ります。また、搬入先はご契約いただくトランクルームに限ります。<br/>
                  ※有料運搬サービスに関するご案内・荷物の運搬は、東都クリエート株式会社へ委託しております。<br/>
                  ハローストレージのお申込み完了後、運搬に関するメールが届きますので、フォームへのご回答をお願いいたします。<br/>
                  ご希望の日程に添えない場合もございますので、余裕を持ったお申込みをお願いいたします。
                </p>
            </div>
            <div className="option-container">
                <h3 className="pc-show"><img src="resource/img/static/carrieservice/option.png" alt="有料オプション 梱包サービスプラス、ダンボール発送"/></h3>
                <h3 className="sp-show"><img src="resource/img/static/carrieservice/option1.png" alt="有料オプション 梱包サービスプラス"/></h3>
                <h3 className="sp-show"><img src="resource/img/static/carrieservice/option2.png" alt="有料オプション 梱包サービスプラス"/></h3>
            </div>
            <div className="container">
                <p className="tel_txt"><img src="resource/img/static/carrieservice/tel_txt.png" alt="お問い合わせ・ご相談はこちらから ハローストレージコールセンター"/></p>
                <p className="tel_btn"><a href="tel:0120-52-4185"><img src="resource/img/static/carrieservice/tel_btn.png" alt="0120-52-4185"/></a></p>
            </div>
        </section>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/Carrieservice.jsx